<template>
  <NButton v-if="!verified" type="primary" shape="round" @click="onGotoVerify">
    {{ $tl('gotoVerify') }}
  </NButton>
</template>

<script setup>
import {useGotoVerify} from '@front/hooks';

const { verified, onGotoVerify } = useGotoVerify();
</script>

<script>
export default {
  name: 'NGoToVerify',
};
</script>
